import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import type { Appointment } from "@/hooks/useAppointments";

export const useArtisanAppointments = (statusFilter?: string) => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["artisan-appointments", user?.id, statusFilter],
    queryFn: async () => {
      if (!user) return [];
      let query = supabase
        .from("appointments")
        .select("*")
        .eq("artisan_user_id", user.id)
        .order("starts_at", { ascending: false });

      if (statusFilter && statusFilter !== "all") {
        query = query.eq("status", statusFilter);
      }

      const { data, error } = await query;
      if (error) throw error;

      // Fetch client names
      const clientIds = [...new Set((data as Appointment[]).map((a) => a.client_user_id))];
      const { data: profiles } = clientIds.length
        ? await supabase
            .from("profiles")
            .select("user_id, first_name, last_name")
            .in("user_id", clientIds)
        : { data: [] };

      const nameMap: Record<string, string> = {};
      (profiles || []).forEach((p) => {
        nameMap[p.user_id] = `${p.first_name} ${p.last_name}`.trim();
      });

      return (data as Appointment[]).map((apt) => ({
        ...apt,
        client_name: nameMap[apt.client_user_id] || "Client",
      }));
    },
    enabled: !!user,
  });
};
